import axios from 'axios';

// Obtener encuestas disponibles para un cliente específico
export const obtenerEncuestasDisponibles = (clienteId) => {
  return new Promise((resolve, reject) => {
    axios.get(`/Encuesta/disponibles/${clienteId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al obtener encuestas disponibles:', error);
        reject(error);
      });
  });
};

// Obtener preguntas de una encuesta específica con sus opciones
export const obtenerPreguntasEncuesta = (encuestaId) => {
  return new Promise((resolve, reject) => {
    axios.get(`/Encuesta/${encuestaId}/preguntas`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al obtener preguntas de la encuesta:', error);
        reject(error);
      });
  });
};

// Guardar respuesta de encuesta
export const guardarRespuestaEncuesta = (datosRespuesta) => {
  return new Promise((resolve, reject) => {
    axios.post(`/Encuesta/responder`, datosRespuesta)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al guardar respuesta de encuesta:', error);
        reject(error);
      });
  });
};

// Función adicional para obtener todas las encuestas (si necesitas esta funcionalidad)
export const obtenerTodasLasEncuestas = () => {
  return new Promise((resolve, reject) => {
    axios.get(`/Encuesta`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al obtener encuestas:', error);
        reject(error);
      });
  });
};

// Crear encuesta
export const crearEncuesta = (datos) => {
  return new Promise((resolve, reject) => {
    axios.post(`/Encuesta/crear`, datos)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al crear encuesta:', error);
        reject(error);
      });
  });
};

// obtener los tipos de evento
export const obtenerTiposEventoEncuesta = () => {
  return new Promise((resolve, reject) => {
    axios.get(`/Encuesta/tipoEventoEncuesta`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al recuperar tipos Evento Encuesta:', error);
        reject(error);
      });
  });
};

// Obtener preguntas de una encuesta específica con sus opciones
export const obtenerEncuesta = (encuestaId) => {
  return new Promise((resolve, reject) => {
    axios.get(`/Encuesta/${encuestaId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al obtener la encuesta:', error);
        reject(error);
      });
  });
};

// Eliminar encuesta por Id
export const eliminarEncuesta = (encuestaId) => {
  return new Promise((resolve, reject) => {
    axios.delete(`/Encuesta/${encuestaId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al eliminar la encuesta:', error);
        reject(error);
      });
  });
};


// Actualizar encuesta por Id
export const actualizarEncuesta = (encuestaId, datosEncuesta) => {
  return new Promise((resolve, reject) => {
    axios.put(`/Encuesta/${encuestaId}`, datosEncuesta)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al actualizar la encuesta:', error);
        reject(error);
      });
  });
};



export const obtenerRespuestasEncuesta = (encuestaId) => {
  return new Promise((resolve, reject) => {
    axios.get(`/Encuesta/${encuestaId}/respuestas`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al obtener la encuesta:', error);
        reject(error);
      });
  });
};

// Enviar encuesta por WhatsApp
export const enviarEncuestaWhatsApp = (datos) => {
  return new Promise((resolve, reject) => {
    axios.post(`/Encuesta/enviar-whatsapp`, datos)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al enviar encuesta por WhatsApp:', error);
        reject(error);
      });
  });
};

// Obtener estadísticas de una encuesta
export const obtenerEstadisticasEncuesta = (encuestaId, fechaInicio = null, fechaFin = null) => {
  return new Promise((resolve, reject) => {
    let url = `/Encuesta/${encuestaId}/estadisticas`;
    const params = [];
    
    if (fechaInicio) {
      params.push(`fechaInicio=${fechaInicio}`);
    }
    if (fechaFin) {
      params.push(`fechaFin=${fechaFin}`);
    }
    
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    axios.get(url)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error('Error al obtener estadísticas de la encuesta:', error);
        reject(error);
      });
  });
};
